import { Plug, Shield, TrendingUp, Glasses, Gift, Share2, Trophy, MessageCircle, Sparkles } from "lucide-react";
import Card from '@/components/common/ui/Card';

const plans = [
    {
        title: "Seamless Integration",
        description:
            "Our solutions easily integrate with existing systems, ensuring a smooth transition and minimal disruption to your operations.",
        icon: Plug,
    },
    {
        title: "Enhanced Security",
        description:
            "Protect your business and customer data with our advanced security measures, providing peace of mind and trust.",
        icon: Shield,
    },
    {
        title: "Scalable Platforms",
        description:
            "Grow your business effortlessly according to your needs, accommodating increased traffic and transactions.",
        icon: TrendingUp,
    },
    {
        title: "Augmented Reality (AR) Shopping",
        description:
            "Integrate AR features that allow customers to visualize products in their environment, enhancing their shopping experience and reducing returns.",
        icon: Glasses,
    },
    {
        title: "Subscription Box Services",
        description:
            "Offer personalized subscription boxes tailored to customer preferences, providing a unique shopping experience that encourages repeat business.",
        icon: Gift,
    },
    {
        title: "Social Commerce",
        description:
            "Utilize social media platforms to sell directly to consumers. Create shoppable posts that link directly to product pages, making it easier for customers to purchase.",
        icon: Share2,
    },
    {
        title: "Gamification Elements",
        description:
            "Incorporate gamification into the shopping experience, such as reward points, badges for frequent buyers, or fun quizzes that suggest products based on preferences.",
        icon: Trophy,
    },
    {
        title: "Live Chat Support",
        description:
            "Enhance customer service with live chat options, providing real-time assistance to shoppers, answering their queries, and increasing conversion rates.",
        icon: MessageCircle,
    },
    {
        title: "AI-Powered Personalization",
        description:
            "Revolutionize your e-commerce experience with intelligent product recommendations, personalized offers, and smart search that adapts to each customer's behavior and preferences.",
        icon: Sparkles,
    },
];

export default function EcommerceExperience() {
    return (
        <section className="container py-12 md:py-16">
            <div className="text-center">
                <h3 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-4">
                    Revolutionize your E-Commerce Experience
                </h3>
                <p className="text-textColor mb-12 max-w-3xl mx-auto text-lg">Explore innovative solutions designed to enhance your online business presence and stimulate growth.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
                {plans.map((plan, index) => (
                    <Card
                        key={index}
                        title={plan.title}
                        description={plan.description}
                        icon={plan.icon}
                    />
                ))}
            </div>
        </section>
    );
}